// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { SettingItem } from './SettingItem';
import { SelectOption } from './SelectOption';
/**
 * 选项组 实体类
 * 选项组包括一组选项
 */
export class SelectGroup extends BaseEntity {
  /** Name : 名称 */
  private _name: string;

  /** 设置：Name */
  public get name() {
    return this._name;
  }

  /** 获取：Name */
  public set name(value: string) {
    this._name = value;
  }

  /** Description : 描述 */
  private _description: string;

  /** 设置：Description */
  public get description() {
    return this._description;
  }

  /** 获取：Description */
  public set description(value: string) {
    this._description = value;
  }

  /** 设置项 */
  private _settingItems: Array<SettingItem>;

  /** 获取：设置项 */
  public get settingItems() {
    return this._settingItems;
  }

  /** 设置：设置项 */
  public set settingItems(value: Array<SettingItem>) {
    this._settingItems = value;
  }

  /** 选项 */
  private _selectOptions: Array<SelectOption>;

  /** 获取：选项 */
  public get selectOptions() {
    return this._selectOptions;
  }

  /** 设置：选项 */
  public set selectOptions(value: Array<SelectOption>) {
    this._selectOptions = value;
  }

  constructor() {
    super();
    this._name = '';
    this._description = '';
    this._settingItems = new Array<SettingItem>();
    this._selectOptions = new Array<SelectOption>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: SelectGroup, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.name = element.name;
      this.description = element.description;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.name = json.Name;
    this.description = json.Description;
    if (json.SettingItems && json.SettingItems.length > 0) {
      json.SettingItems.forEach((element: any) => {
        const settingItem = SettingItem.Create(element);
        // settingItem.selectGroup = this;
        this.settingItems.push(settingItem);
      });
    }
    if (json.SelectOptions && json.SelectOptions.length > 0) {
      json.SelectOptions.forEach((element: any) => {
        const selectOption = SelectOption.Create(element);
        // selectOption.selectGroup = this;
        this.selectOptions.push(selectOption);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Name = this.name;
    json.Description = this.description;
    if (this.settingItems && this.settingItems.length > 0) {
      json.SettingItems = [];
      this.settingItems.forEach((element) => {
        json.SettingItems.push(element.toJson());
      });
    }
    if (this.selectOptions && this.selectOptions.length > 0) {
      json.SelectOptions = [];
      this.selectOptions.forEach((element) => {
        json.SelectOptions.push(element.toJson());
      });
    }
  }

  static Create(json: any): SelectGroup {
    const selectGroup = new SelectGroup();
    selectGroup.Deserialize(json);
    selectGroup.json = json;
    return selectGroup;
  }
}
